import React from 'react';
import styles from './utility.module.scss';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    children: React.ReactNode;
    size: 'xs' | 'sm' | 'md' | 'lg';
}

export function HideElement({children, size}: OwnProps) {
    return (
        <div
            className={classNames(styles.hide_element, {
                [styles.hide_xs]: size === 'xs',
                [styles.hide_sm]: size === 'sm',
                [styles.hide_md]: size === 'md',
                [styles.hide_lg]: size === 'lg',
            })}
        >
            {children}
        </div>
    );
}
